import React from 'react'

import style from './Body.module.css'

const Body = ({ children }) => {
  return <tbody className={style.body}>{children}</tbody>
}

export default Body
